import React from 'react';
import { cn } from '../../utils/cn';

type Direction = 'higher' | 'lower' | 'correct' | 'unknown';

interface DirectionBadgeProps {
  direction: Direction;
  className?: string;
}

const BADGE_CONFIG: Record<Direction, { label: string; icon: string; colorClasses: string }> = {
  higher: {
    label: 'HIGHER',
    icon: '\u2191',
    colorClasses: 'text-blue-600 dark:text-blue-400 bg-blue-100/60 dark:bg-blue-900/30 border-blue-300/50 dark:border-blue-700/50'
  },
  lower: {
    label: 'LOWER',
    icon: '\u2193',
    colorClasses: 'text-orange-600 dark:text-orange-400 bg-orange-100/60 dark:bg-orange-900/30 border-orange-300/50 dark:border-orange-700/50'
  },
  correct: {
    label: 'MATCH',
    icon: '\u2713',
    colorClasses: 'text-green-600 dark:text-green-400 bg-green-100/60 dark:bg-green-900/30 border-green-300/50 dark:border-green-700/50'
  },
  unknown: {
    label: 'UNKNOWN',
    icon: '?',
    colorClasses: 'text-gray-500 dark:text-gray-400 bg-gray-100/60 dark:bg-gray-800/30 border-gray-300/50 dark:border-gray-600/50'
  }
};

/**
 * DirectionBadge - Pill-shaped badge showing higher/lower/correct/unknown direction
 * for market cap comparison in guess history.
 */
export const DirectionBadge: React.FC<DirectionBadgeProps> = ({ direction, className }) => {
  const config = BADGE_CONFIG[direction];

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 rounded-full border',
        'font-mono text-[10px] font-semibold uppercase tracking-wider whitespace-nowrap',
        config.colorClasses,
        className
      )}
    >
      <span className="leading-none">{config.icon}</span>
      <span className="leading-none">{config.label}</span>
    </span>
  );
};
